import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';

export const EquipmentTableHeaders = ({
  t,
  onSort,
}: SortableTableHeadersProps) => {
  return (
    <>
      {/* <TableHead thClassName="min-w-0 w-0" /> */}
      <TableHead
        text={t('common:equipments')}
        thClassName="min-w-[255px]"
        sortable
        onSortClick={() => onSort?.('equipmentName')}
      />
      <TableHead
        text={t('common:multiple')}
        thClassName="text-center min-w-0 w-0"
      />
      <TableHead
        text={t('common:status')}
        thClassName="text-center min-w-0 w-0"
      />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
